import { MessageSquare } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { formatDateTime } from '@/utils/formatDate'

interface ThreadBoundaryProps {
  threadId: number
  startedAt: string
  endedAt: string | null
  messageCount: number
  isActive: boolean
}

export function ThreadBoundary({
  threadId,
  startedAt,
  endedAt,
  messageCount,
  isActive,
}: ThreadBoundaryProps) {
  return (
    <div className="flex items-center gap-4 rounded-lg border-b-2 border-primary/20 bg-primary/5 p-4">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
        <MessageSquare className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <span className="text-lg font-bold">스레드 #{threadId}</span>
          {isActive ? (
            <Badge variant="success">활성</Badge>
          ) : (
            <Badge variant="secondary">종료됨</Badge>
          )}
        </div>
        <p className="text-sm text-muted-foreground">
          시작: {formatDateTime(startedAt)}
          {endedAt && ` • 종료: ${formatDateTime(endedAt)}`}
        </p>
      </div>
      <div className="text-right">
        <p className="text-2xl font-bold text-primary">{messageCount}</p>
        <p className="text-xs text-muted-foreground">메시지</p>
      </div>
    </div>
  )
}
